import React from "react";
import { useNavigate } from "react-router-dom";
import './danlayout.css';

const DanLayout = ({
  beltName,
  patterns, // Array of 3 pattern objects
  fundamentalmovementsHtml, // New prop for fundamental movements
}) => {
  const navigate = useNavigate();
  return (
    <div className="belt-page">
      <div className="belt-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h2 className="belt-name">{beltName}</h2>
        {patterns.map((pattern, index) => (
          <div key={index} className="pattern-section">
            <div
              className="pattern-name"
              dangerouslySetInnerHTML={{ __html: pattern.name }}
            />
            <div
              className="pattern-meaning"
              dangerouslySetInnerHTML={{ __html: pattern.meaning }}
            />
            <div
              className="video-link"
              dangerouslySetInnerHTML={{ __html: pattern.videoLinkText }}
            />
            <div className="video-diagram-row">
              <img
                src={pattern.diagramImage}
                alt={`Diagram for ${pattern.name}`}
                className="diagram-image"
              />
              <div
                className="moves-list"
                dangerouslySetInnerHTML={{ __html: pattern.movesHtml }}
              />
            </div>
            <h4 className="technique-heading">Techniques</h4>
            <div
              className="technique-text"
              dangerouslySetInnerHTML={{ __html: pattern.techniqueHtml }}
            />
          </div>
        ))}
        {/* Fundamental Movements Section */}
        <h4 className="fundamental-movements-heading">Fundamental Movements</h4>
        <div
          className="fundamental-movements-text"
          dangerouslySetInnerHTML={{ __html: fundamentalmovementsHtml }}
        />
      </div>
    </div>
  );
};

export default DanLayout;
